import HxTableResult from "./main.vue"

/* istanbul ignore next */
HxTableResult.install = function(Vue) {
  Vue.component(HxTableResult.name, HxTableResult)
}

export default HxTableResult
